export default "__VITE_ASSET__6fb06cf3__"